<template>
  <span class="mt-2"> Acesse <a href="#" class="acess" @click.prevent="redirect('homePage')">aqui</a></span>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import { mapState } from 'pinia'
  import router from '../../router'

  export default defineComponent({
    name: 'FaqStatusAccount',
    computed: {
      ...mapState(localeStore, ['locale'])
    },
    methods: {
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          }
        })
      }
    }
  })
</script>
<style scoped lang="css">
  .acess {
    color: brown;
    font-weight: 700;
    cursor: pointer;
  }
  .acess:hover {
    background-color: unset;
    text-decoration: underline;
  }
</style>
